import {
  Container,
  ColumnLayout,
  Header,
  Box,
  SpaceBetween,
  Link,
} from "@cloudscape-design/components-themed";
import { isEmpty } from "lodash";
import { Dispatch, SetStateAction } from "react";
import { MerchantInfoForBankAccount } from "../../../features/api-interfaces";
import { formatDate, formatLabel } from "../../../utils/format";
import { updatingInfoType, UPDATING_INFO, LABELS } from "../constants";
import { MerchantInfoExpandableSection } from "./MerchantInfoExpandableSection";

interface IMerchantInfo {
  updatingInfo?: string;
  applyingDate?: string;
  merchantInfoList?: MerchantInfoForBankAccount[];
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
}

/**
 * 入金口座情報照会・更新 加盟店情報
 */
export const MerchantInfo = (props: IMerchantInfo) => {
  const { updatingInfo, applyingDate, merchantInfoList, setIsModalOpen } =
    props;
  const displayApplyingDate = formatDate(applyingDate);

  /**
   * 情報更新中のテキストを返却する.
   * @returns {JSX.Element}
   */
  const updateInfoContent = () => {
    const updatingType = (updatingInfo ?? "") as updatingInfoType;

    const contentObj: Record<updatingInfoType, JSX.Element> = {
      [UPDATING_INFO.COMPANY_INFO]: (
        <h4>
          {formatLabel(LABELS.UPDATING_INFO_TEXT, [UPDATING_INFO.COMPANY_INFO])}
        </h4>
      ),
      [UPDATING_INFO.BANK_ACCOUNT]: (
        <Link onFollow={() => setIsModalOpen(true)}>
          <h4>
            {formatLabel(LABELS.UPDATING_INFO_TEXT, [
              UPDATING_INFO.BANK_ACCOUNT,
            ])}
          </h4>
        </Link>
      ),
      [UPDATING_INFO.NONE]: <></>,
    };

    return contentObj[updatingType];
  };

  return (
    <Container
      header={
        <ColumnLayout columns={2}>
          <Header variant={"h2"}>{LABELS.MERCHANT_INFO_TITLE}</Header>
          <Box float={"right"}>
            <SpaceBetween direction={"horizontal"} size={"xs"}>
              {updateInfoContent()}
              {!isEmpty(displayApplyingDate) && (
                <h4>{LABELS.APPLYING_DATE + displayApplyingDate}</h4>
              )}
            </SpaceBetween>
          </Box>
        </ColumnLayout>
      }
    >
      <SpaceBetween direction={"vertical"} size={"xxs"}>
        <MerchantInfoExpandableSection
          headerText={LABELS.IPID_TITLE}
          merchantInfoList={merchantInfoList}
        />
      </SpaceBetween>
    </Container>
  );
};
